import axios from '@/plugins/axios'
import { CancelReasonClient, CMMFClient, CustomerClient, DelegationClient, LoginClient, PromotionClient, SalesOrgClient, SamlClient, SnpMappingClient, UserClient, UserRoleClient } from '@/services/connecteur'
import { getModule, Module, VuexModule } from 'vuex-module-decorators'
import store from '@/store'

@Module({ namespaced: true, name: 'serviceModule', store, dynamic: true })
export class ServiceModule extends VuexModule {
    readonly _samlApi = new SamlClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _promotionApi = new PromotionClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _cancelReasonApi = new CancelReasonClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _userApi = new UserClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _salesOrgApi = new SalesOrgClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _customerApi = new CustomerClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _delegationApi = new DelegationClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _userRoleApi = new UserRoleClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _cmmfApi = new CMMFClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _loginApi = new LoginClient(process.env.VUE_APP_BACK_URL, axios);
    readonly _snpMappingApi = new SnpMappingClient(process.env.VUE_APP_BACK_URL, axios);

    get samlApi () { return this._samlApi }
    get promotionApi () { return this._promotionApi }
    get cancelReasonApi () { return this._cancelReasonApi }
    get userApi () { return this._userApi }
    get salesOrgApi () { return this._salesOrgApi }
    get customerApi () { return this._customerApi }
    get delegationApi () { return this._delegationApi }
    get userRoleApi () { return this._userRoleApi }
    get cmmfApi () { return this._cmmfApi }
    get loginApi () { return this._loginApi }
    get snpMappingApi () { return this._snpMappingApi }
}

export default getModule(ServiceModule)
